export { Firebase } from "./Service";
